import { defineComponent } from 'vue';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import SearchInputCode from '@/presentation/components/entities-and-geotargeting/table-entities-search/search-input.code';

export default defineComponent({
	components: {
		LoadingWrapper
	},
	setup: () => {
		const code = new SearchInputCode();

		return {
			isLoading: code.isLoading,
			searchWrapper: code.searchWrapper,
			searchTerm: code.searchTerm,
			tableEntitiesSearchInput: code.tableEntitiesSearchInput,
			setSearchTerm: code.setSearchTerm.bind(code)
		};
	}
});
